document.querySelectorAll('.video-settings-box').forEach(box => {
  box.addEventListener('click', () => {
    if (window.innerWidth < 768) {
      const cover = box.querySelector('.video-settings-box-cover');
      if (cover) {
        const currentOpacity = window.getComputedStyle(cover).opacity;
        if (currentOpacity === '1') {
          cover.style.opacity = '0';
        } else {
          cover.style.opacity = '1';
        }
      }
    }
  });
});
